/**
 * Route middleware guard for the receipts feature.
 *
 * Prevents navigation to billing/receipts and its children when the receipts
 * feature is disabled for the tenant. Redirects to the billing page instead.
 */
export default defineNuxtRouteMiddleware(() => {
  const appConfig = useAppConfig();

  if (appConfig.features.receipts) return;

  const localePath = useLocalePath();
  return navigateTo(localePath('/billing'));
});
